import { Typography } from "@mui/material";

import { BannerContainer, Arrow } from "./styles";

const Banner = () => {
  const message = "Make 'em Laugh! Fun Video Ecards and Greetings Starring You®, Family & Friends";

  return (
    <BannerContainer>
      <Typography component="span" variant="h6" fontWeight="medium" color="neutral.main">
        {message}
      </Typography>
      <Arrow />
    </BannerContainer>
  );
};

export default Banner;
